import {
  isNil, isEmpty,
} from 'lodash';
import { Location } from 'lib/types';
import { decodeBase32, encodeBase32 } from 'geohashing';

const SLUG_DELIMITER = '~';

/**
We want to have the front end urls of the explore page have human readable values
in the query params. But want to avoid making extra api calls and or joins by trying to query
with those human readable values.

So we put the IDs in a slug with a readable value so we can get the  id later
for querying while still adding some readability.
e.g. users=leela~2
 */
export function modelToSlug(
  modelObj: any,
  humanReadableField: string,
  humanReadableFallback?: string,
) {
  if (isNil(modelObj) || isEmpty(modelObj)) {
    return '';
  }
  const humanReadableValue = modelObj[humanReadableField] || humanReadableFallback || 'unknown';
  return `${humanReadableValue}${SLUG_DELIMITER}${modelObj.id}`;
}

export function humanReadableFromSlug(slug: string) {
  if (!slug) {
    return '';
  }

  return slug.split(SLUG_DELIMITER)[0];
}

export const locationNameToQuery = (name: string) => name.replaceAll(', ', '--').replaceAll(' ', '-');
export const locationNameFromQuery = (name: string) => name.replaceAll('--', ', ').replaceAll('-', ' ');
export const locationToSlug = (location: Partial<Location>) => {
  const hash = location.geohash || (
    location.x && location.y && encodeBase32(location.y, location.x)
  );
  const name = locationNameToQuery(location.name || '');
  return `${name}~${hash}`;
};
export const geoSlugToLocation = (geo: string): Partial<Location> | undefined => {
  try {
    const [queryName, geohash] = geo.split(SLUG_DELIMITER);
    const name = locationNameFromQuery(queryName);
    const ll = decodeBase32(geohash);
    return {
      name,
      x: ll.lng,
      y: ll.lat,
    };
  } catch (err) {
    return undefined;
  }
};
